module.exports = __webpack_public_path__ + "img/dress2.37120715.jpeg";